import { setAlert, setSnackBar, setUser } from "features/common/commonSlice"
import { AuthUser } from "interfaces/dataInterfaces"
import { useAppDispatch } from "./hooksStore"

const useCommon = () => {
  const dispatch = useAppDispatch()

  const showSnackBar = async (message: string, type = "success") => {
    dispatch(setSnackBar({ message, type }))
  }

  const hideSnackBar = async (message = "") => {
    dispatch(setSnackBar({ message }))
  }

  const showAlert = async (alertMessage: string, alertType = "success") => {
    dispatch(setAlert({ alertMessage, alertType }))
  }

  const hideAlert = async (alertMessage = "") => {
    dispatch(setAlert({ alertMessage }))
  }

  const setAuthUser = async (data: AuthUser | null) => {
    dispatch(setUser(data))
  }

  return { showSnackBar, hideSnackBar, showAlert, hideAlert, setAuthUser }
}

export default useCommon
